/**
 * @class
 */
import Base from '@netx/core/lib/netx-view';
import Template from '../templates/appModalCrumbView.html';

class AppModalCrumbView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.template = Template;
		super(opts);

		// Related view
		this.model.has('view')
			? this.addRelatedView()
			: this.listenToOnce(this.model, 'change:view', this.addRelatedView);
	}

	/** @override */
	bindModelEvents() {
		super.bindModelEvents();
		return this.listenTo(this.model, 'change:active', this.toggleActive);
	}

	/** @override */
	preRender() {
		super.preRender();

		const modalOptions =
			(this.relatedView && this.relatedView.modalOptions) || {};
		// Additional template vars
		Object.assign(this.templateVars, {
			action: this.model.get('uniqueShowAction') || '',
			label:
				modalOptions.crumbLabel ||
				this.model.get('label') ||
				modalOptions.headerTitle ||
				(this.relatedView && this.relatedView.headerTitle) ||
				'',
		});
	}

	/** @override */
	postRender() {
		super.postRender();

		// Cache
		this.$remove = this.$('.nx-action[data-action="app:remove:modalView"]');
		this.$title = this.$('.nx-title');

		if (this.relatedView) {
			// Check modal options
			var modalOptions = this.relatedView.modalOptions || {};
			this.$remove.toggle(modalOptions.blocking !== true);
		}
	}

	/**
	 * Once our model has its view property,
	 * remeber it at .relatedView, and use it to toggle our crumbs.
	 * (.relatedView also used in theme override ...)
	 * @method
	 */
	addRelatedView() {
		this.relatedView = this.model.get('view');
		var modalOptions = this.relatedView.modalOptions || {};
		this.$el.toggle(modalOptions.noCrumb !== true);
	}

	/** @method */
	toggleActive() {
		this.$el.toggleClass('active', this.model.get('active') === true);
		// Update title (it could have changed context)
		if (this.relatedView) {
			var modalOpts = this.relatedView.modalOptions || {};
			this.$title &&
				this.$title.html(
					modalOpts.crumbLabel ||
						_.escape(this.model.get('label')) ||
						_.escape(modalOpts.headerTitle) ||
						_.escape(this.relatedView.headerTitle),
				);
		}
	}

	/**
	 * @static
	 * @type {string}
	 */
	static get __name__() {
		return 'AppModalCrumbView';
	}
}

export default AppModalCrumbView;
